module.exports = __webpack_public_path__ + "img/pc_character6@2x.cd765b20.png";